import React, { useEffect, useState } from 'react'
import { useLocaleStore } from '../../Contexts/localeStore'
import { useRetorik } from '../../Contexts/RetorikContext'
import { useView } from '../../Contexts/ViewContext'
import { setFullScreenImage } from '../../Contexts/utilsStore'
import { Mode } from '../../../models/enums'
import translation from '../../../translations/menu.json'
import useFullscreenImage from '../../../hooks/useFullscreenImage'
import Template from '../../Templates/FullScreenRemoteClosing'

const FullScreenImage = (): JSX.Element => {
  const locale = useLocaleStore((state) => state.locale)
  const fullScreenImage = useFullscreenImage()
  const { mode } = useRetorik()
  const { isMobile } = useView()
  const [content, setContent] = useState<string | undefined>()

  useEffect(() => {
    setContent(fullScreenImage)
  }, [fullScreenImage])

  const handleClose = (): void => {
    setFullScreenImage(undefined)
  }

  return content ? (
    <Template
      handleClose={handleClose}
      mobileReturnTitle={
        translation[locale]?.backconversation ||
        translation['fr-FR'].backconversation
      }
    >
      <div
        className={`rf-h-full rf-w-full ${
          isMobile ? (mode === Mode.text ? 'rf-mb-28' : 'rf-mb-16') : 'rf-pt-12'
        } rf-px-8 rf-pb-12 rf-flex rf-justify-center rf-items-center`}
      >
        <img className='rf-max-h-full rf-max-w-full' src={content} />
      </div>
    </Template>
  ) : (
    <React.Fragment />
  )
}

export default FullScreenImage
